import { LOGO, CONTACT, NAICS } from "../../data/content";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img src={LOGO} alt="Atlas Contracting Group" className="h-24 md:h-28 w-auto max-w-full object-contain -ml-1 mb-5" />
            <p className="font-body text-sm text-neutral-500 max-w-xs leading-relaxed">
              Veteran-Owned Small Business providing tactical equipment, safety products, operational supplies, and procurement support to government agencies.
            </p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500 mb-4">Entity</p>
            <ul className="space-y-2 font-mono text-sm text-neutral-400">
              <li>UEI — HE6XT44NU883</li>
              <li>CAGE — 21G51</li>
              <li>SAM — Active</li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500 mb-4">Contact</p>
            <ul className="space-y-2 font-body text-sm text-neutral-400">
              <li>{CONTACT.name} — {CONTACT.title}</li>
              <li><a href={CONTACT.phoneHref} className="hover:text-white transition-colors">{CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors break-all">{CONTACT.email}</a></li>
              <li>{CONTACT.location}</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-xs uppercase tracking-widest text-neutral-600">© {new Date().getFullYear()} Atlas Contracting Group LLC</p>
          <p className="font-mono text-xs uppercase tracking-widest text-neutral-600">NAICS {NAICS.map((n) => n.code).join(" · ")}</p>
        </div>
      </div>
    </footer>
  );
};
